import { Values } from '@lib/interfaces/form';
import UserFieldNames from '@lib/enums/fieldNames/userFieldNames';
import getPhoneNumberValueFromQueryData from '@lib/utils/getPhoneNumberValueFromQueryData';

export default function getDefaultValuesFromQueryData(data?: Values): Values {
  return {
    ...data,
    [UserFieldNames.PhoneNumber]: getPhoneNumberValueFromQueryData(data),
  };
}
